<!--
 * @Author: Peng Bo Wei
 * @Date: 2021-11-02 09:06:29
 * @LastEditors: Peng Bo Wei
 * @LastEditTime: 2021-11-15 21:41:55
 * @Description: 
-->
<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
  >
    <table-form
      :dataSource="dataSource"
      ref="form"
      :tableData="data"
    ></table-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import TableForm from "common/components/form/tableForm2";
import { gqstep21, zqstep2 } from "@/conf/Report-manager";
import { saveReportMgrFund, updateMgrFund } from "common/js/api";
export default {
  components: {
    TableForm,
  },

  props: ["dialogVisible", "title", "data", "codeId"],

  data() {
    return {
      dataSource: [],
      dialogFormVisible: false,
      formData: {},
    };
  },

  created() {
    // 设置配环境
    console.log("step2DialogGQ.vue");
  },

  mounted() {
    this.setConf();
  },

  methods: {
    async setConf() {
      const fillType = this.$store.state.ReportData.reportFillType;
      console.log("tian jia getFillType using", fillType);

      if (fillType == "gq") {
        this.dataSource = gqstep21;
      }
      if (fillType == "zq") {
        this.dataSource = zqstep2;
      }
    },

    async submit() {
      const isValidate = this.$refs.form.submitForm();
      if (!isValidate) return false;
      let form = this.$refs.form.form;

      // code id
      form.reportCode = this.codeId;

      if (form.associtionRegisted == "是") {
        form.associtionRegisted = 1;
      }
      if (form.associtionRegisted == "否") {
        form.associtionRegisted = 0;
      }

      if (this.title.includes("编辑")) {
        form.id = this.data.id;
        console.log("更新基金机构报文", form);
        const ret = await updateMgrFund(form);
        console.log("更新基金机构报文完成", ret);
      } else {
        console.log("添加基金机构报文", form);
        const ret = await saveReportMgrFund(form);
        console.log("添加基金机构报文完成", ret);
      }

      const message = this.title.includes("添加") ? "添加" : "编辑";
      this.$message({
        message: `基金信息${message}成功!`,
        type: "success",
      });
      this.$emit("reload");
      this.handleClose();
    },

    handleClose() {
      this.formData = {};
      this.dialogFormVisible = false;
      this.$emit("closeDialog");
    },
  },

  watch: {
    dialogVisible(newValue) {
      this.dialogFormVisible = newValue;
    },
  },
};
</script>

